import { Tour } from "antd";
import { useEffect } from "react";
import type { TourContext } from "./raidTourStore";
import { raidTourStore, useRaidTourStore } from "./raidTourStore";
import { getStepsForContext } from "./tourSteps";
import { RaidTourLauncher } from "./RaidTourLauncher";
import type { Raid } from "@/raids/rest/RaidSchema";

const AUTO_START_DELAY = 600;

function contextForStatus(status: Raid["status"] | undefined): TourContext | null {
  if (status === "CREATED") return "raid-edit-created";
  if (status === "RUNNING") return "raid-edit-running";
  return null;
}

type Props = {
  raidStatus: Raid["status"] | undefined;
};

export function RaidEditTour({ raidStatus }: Props) {
  const { activeContext, close } = useRaidTourStore();

  const ctx = contextForStatus(raidStatus);

  useEffect(() => {
    if (!ctx) return;
    const { hasSeen, start } = raidTourStore.getState();
    if (hasSeen(ctx)) return;
    const timer = window.setTimeout(() => {
      if (!raidTourStore.getState().hasSeen(ctx)) start(ctx);
    }, AUTO_START_DELAY);
    return () => clearTimeout(timer);
  }, [ctx]);

  const isOpen = ctx != null && activeContext === ctx;
  const steps = ctx ? getStepsForContext(ctx) : [];

  return (
    <>
      <Tour open={isOpen} steps={steps} onClose={close} onFinish={close} />
      {ctx && <RaidTourLauncher context={ctx} />}
    </>
  );
}
